import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-74735bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = {
  class: "checkbox-list",
  "data-test": "cms-checklist"
}
const _hoisted_4 = ["id", "value", "disabled", "data-test"]
const _hoisted_5 = ["data-test", "for"]

import axios from "axios";
import { debug as d } from "debug";
import { computed, ref } from "vue";
import { SessionQuestionnaireApiModel } from "../../api-models";

export interface AnswerData {
  answerId: string;
  answerLabel: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-checklist',
  props: {
    maxChoices: {},
    answers: {},
    isShuffle: { type: Boolean },
    checklistId: {},
    questionnaire: {}
  },
  setup(__props: any) {

const debug = d("cs.CmsChecklist");

const props = __props;

const inputs = ref<string[]>(
  props.questionnaire.answers[props.checklistId]?.map((element) => {
    return element;
  }) || [],
);

function shuffleArray(array: AnswerData[]): AnswerData[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

const answers = computed(() => {
  return props.isShuffle ? shuffleArray(props.answers) : props.answers;
});

function disabledText(id: string): boolean {
  return inputs.value.length === props.maxChoices && !inputs.value.includes(id);
}

async function inputHandler(): Promise<void> {
  axios
    .patch(`/api/sessionquestionnaire/${props.questionnaire?.id}/answers`, {
      [props.checklistId]: inputs.value,
    })
    .then((resp) => {
      if (resp.status === 200) {
        debug("success!");
      }
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Choose " + _toDisplayString(props.maxChoices) + " from the options below: ", 1),
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (data, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: `checkbox-input-${index}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputs).value = $event)),
            value: data.answerId,
            disabled: inputs.value.length > props.maxChoices - 1 && inputs.value.indexOf(data.answerId) === -1,
            onChange: inputHandler,
            "data-test": `cms-checkbox-${index}`
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, inputs.value]
          ]),
          _createElementVNode("label", {
            class: _normalizeClass(["checkbox-control", { 'disabled-text': disabledText(data.answerId) }]),
            "data-test": `cms-checklist-label-${index}`,
            for: `checkbox-input-${index}`
          }, _toDisplayString(data.answerLabel), 11, _hoisted_5)
        ]))
      }), 128))
    ])
  ]))
}
}

})